import React from 'react';
import {TextMessage,ITextMessage} from "./TextMessage";
import {ImageMessage, IImageMessage} from "./ImageMessage";
import {StickerMessage, IStickerMessage} from "./StickerMessage";
import {AudioMessage, IAudioMessage} from "./AudioMessage";
import {VideoMessage, IVideoMessage} from "./VideoMessage";
import {DocumentMessage, IDocumentMessage } from "./DocumentMessage";
import {ListMessage, IListMessage } from "./ListMessage";
import {ListReplyMessage,IListReplyMessage} from "./ListReplyMessage";
import {ReplyButtonMessage,IReplyButtonMessage} from "./ReplyButtonMessage";
import {ButtonReplyMessage,IButtonReplyMessage} from "./ButtonReplyMessage";
import { PrivacyAndComplianceMessage,IPrivacyAndComplianceMessage} from "./PrivacyAndComplianceMessage";

export interface IMessageTypeDescriptor {

    create : (props, index:number) => JSX.Element;

}

export interface IMessageFactory {

    [type: string]: IMessageTypeDescriptor
}

export class MessageFactoryImpl 
    implements IMessageFactory {


        [type: string] : IMessageTypeDescriptor
    
}

export const MessageFactory  : MessageFactoryImpl = {};


MessageFactory["Miles.Research.Dialogs.TextMessage, Miles.Research.Dialogs"] = { create : function(props:ITextMessage, index:number) {return <TextMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ImageMessage, Miles.Research.Dialogs"] = {create : function(props:IImageMessage, index:number) {return <ImageMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.StickerMessage, Miles.Research.Dialogs"] = {create : function(props:IStickerMessage, index:number) {return <StickerMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.AudioMessage, Miles.Research.Dialogs"] = {create : function(props:IAudioMessage, index:number) {return <AudioMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.VideoMessage, Miles.Research.Dialogs"] = {create : function(props:IVideoMessage, index:number) {return <VideoMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.DocumentMessage, Miles.Research.Dialogs"] = {create : function(props:IDocumentMessage, index:number) {return <DocumentMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ListMessage, Miles.Research.Dialogs"] = {create : function(props:IListMessage, index:number) {return <ListMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ListReplyMessage, Miles.Research.Dialogs"] = {create : function(props:IListReplyMessage, index:number) {return <ListReplyMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ReplyButtonMessage`1[[Miles.Research.Dialogs.MediaItem, Miles.Research.Dialogs]], Miles.Research.Dialogs"] = {create : function(props:IReplyButtonMessage, index:number) {return <ReplyButtonMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ReplyButtonMessage`1[[System.String, System.Private.CoreLib]], Miles.Research.Dialogs"] = {create : function(props:IReplyButtonMessage, index:number) {return <ReplyButtonMessage key={index} {...props} />; } }
MessageFactory["Miles.Research.Dialogs.ButtonReplyMessage, Miles.Research.Dialogs"] = {create : function(props:IButtonReplyMessage, index:number) {return <ButtonReplyMessage key={index} {...props} />; } }
MessageFactory["PrivacyAndComplianceMessage"] = {create : function(props:IPrivacyAndComplianceMessage, index:number) {return <PrivacyAndComplianceMessage key={index} {...props} />; } }

